'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('cast-vote', {
      url: '/vote/:voteId/ballot/:id/cast',
      template: '<cast-vote></cast-vote>',
        authenticate: true
    })
    .state('cast-vote-paper', {
    url: '/vote/:voteId/ballot/:id/cast/paper',
    params: {properties: null},
    template: '<cast-vote mode="paper"></cast-vote>',
    authenticate: 'admin'
  })
    .state('cast-vote-proxy', {
    url: '/vote/:voteId/ballot/:id/cast/proxy',
    params: {properties: null, proxyName: null},
    template: '<cast-vote mode="proxy"></cast-vote>',
    authenticate: 'admin'
  });
}



// WEBPACK FOOTER //
// ./client/app/cast-vote/property/cast-vote.routes.js